// Feature flags configuration
export const featureFlags = {
  // Hide language selector and multilingual features
  hideLanguageSelector: true,
  
  // Hide video/coffee portfolio sections
  hideVideoSection: true,
  hideCoffeeSection: true,
  
  // Future feature flags can be added here
  // enableNewFeature: false,
  // showBetaContent: false,
};

export default featureFlags;